<template>
  <div class="background-audio">
    <!-- Mute/Unmute Button -->
    <button @click="toggleAudio" class="mute-button">
      <!-- Muted Icon -->
      <svg v-if="isMuted" xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 24 24" fill="currentColor">
        <path d="M13.5 4.06c0-1.336-1.616-2.005-2.56-1.06l-4.5 4.5H4.508c-1.141 0-2.318.664-2.66 1.905A9.76 9.76 0 001.5 12c0 .898.121 1.768.35 2.595.341 1.24 1.518 1.905 2.659 1.905h1.93l4.5 4.5c.945.945 2.561.276 2.561-1.06V4.06zM17.78 9.22a.75.75 0 10-1.06 1.06L18.44 12l-1.72 1.72a.75.75 0 001.06 1.06l1.72-1.72 1.72 1.72a.75.75 0 101.06-1.06L20.56 12l1.72-1.72a.75.75 0 00-1.06-1.06l-1.72 1.72-1.72-1.72z" />
      </svg>
      <!-- Playing/Sound Icon -->
      <svg v-else xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 24 24" fill="currentColor">
        <path d="M13.5 4.06c0-1.336-1.616-2.005-2.56-1.06l-4.5 4.5H4.508c-1.141 0-2.318.664-2.66 1.905A9.76 9.76 0 001.5 12c0 .898.121 1.768.35 2.595.341 1.24 1.518 1.905 2.659 1.905h1.93l4.5 4.5c.945.945 2.561.276 2.561-1.06V4.06zM18.584 5.106a.75.75 0 011.06 0c3.808 3.807 3.808 9.98 0 13.788a.75.75 0 11-1.06-1.06 8.25 8.25 0 000-11.668.75.75 0 010-1.06z" />
        <path d="M15.932 7.757a.75.75 0 011.061 0 4.5 4.5 0 010 6.364.75.75 0 01-1.06-1.06 3 3 0 000-4.243.75.75 0 010-1.06z" />
      </svg>
    </button>
    <!-- preload="none" is load-bearing, not a nicety: this component is mounted
         on every page via App.vue, the track is 3.7MB, and it starts muted and
         never plays until the button is tapped. Without the attribute the
         browser defaults to preload="metadata" and pulls the file anyway —
         measured readyState 4 with 4s buffered on a plain home-page visit,
         which is real mobile data spent before the student does anything. -->
    <audio ref="audio" :src="audioSrc" loop preload="none"></audio>
  </div>
</template>

<script>
export default {
  name: "BackgroundAudio",
  data() {
    return {
      audioSrc: require('@/assets/sounds/output.mp3'),
      isMuted: true, // Default to true because the audio is paused initially
    };
  },
  methods: {
    toggleAudio() {
      const audio = this.$refs.audio;
      if (audio) {
        if (audio.paused) {
          audio.play();
        } else {
          audio.pause();
        }
        this.isMuted = audio.paused;
      } else {
        console.error("Audio element not found.");
      }
    },
  },
};
</script>

<style scoped>
.background-audio {
  position: fixed;
  bottom: 1.2rem;
  right: 1.2rem;
  /* Above page content, but BELOW every overlay in the app (100/300/400/1000).
     At 900 this floating button painted over in-page modals and swallowed taps
     meant for their primary action on a phone. */
  z-index: 90;
}

.mute-button {
  border: 2px solid #E8E0D2;
  cursor: pointer;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background-color: #FFFFFF;
  color: #8E8577;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 0 #E8E0D2;
  transition: transform 0.1s, box-shadow 0.1s, color 0.15s;
}

.mute-button:hover {
  color: #1CB0F6;
  border-color: #A8E1FF;
}

.mute-button:active {
  transform: translateY(3px);
  box-shadow: 0 1px 0 #E8E0D2;
}

.icon {
  width: 24px;
  height: 24px;
}
</style>